import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/auth/helpers/app-config';
import { Message } from '../models/message';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  constructor(private http:HttpClient,private config:AppConfig) {
   
   }

  getMessages(id:string):Observable<Message>{
    return this.http.get<Message>(`${this.config.api}/client/messages/${id}/`)
  }
}
